export default __webpack_public_path__ + "static/media/Pruksa Logo A.6b69322e.png";